import {
  DashboardOutlined,
  FileTextOutlined,
  ShopOutlined,
  SwapOutlined,
  UserOutlined,
  BarChartOutlined,
  PlusOutlined,
  UnorderedListOutlined,
  SaveOutlined,
  SearchOutlined,
  HeartOutlined,
  DollarOutlined,
  PhoneOutlined,
  TeamOutlined,
  ProfileOutlined,
  SafetyOutlined,
  SettingOutlined,
  BellOutlined,
  LineChartOutlined,
  PieChartOutlined,
  RiseOutlined,
  UploadOutlined,
  WalletOutlined,
  TransactionOutlined,
  GiftOutlined
} from '@ant-design/icons';

// 菜单配置
export const menuConfig = [
  {
    key: 'publish-debt',
    title: '发布债权',
    icon: PlusOutlined,
    path: '/debt-management/publish'
  },
  {
    key: 'debt-marketplace',
    title: '债权广场',
    icon: ShopOutlined,
    path: '/debt-marketplace',
    children: [
      {
        key: 'browse-debts',
        title: '浏览债权',
        icon: SearchOutlined,
        path: '/debt-marketplace/browse'
      },
      {
        key: 'favorites',
        title: '收藏夹',
        icon: HeartOutlined,
        path: '/debt-marketplace/favorites'
      }
    ]
  },
  {
    key: 'my-debts',
    title: '我的债权',
    icon: UnorderedListOutlined,
    children: [
      {
        key: 'my-debts-list',
        title: '我的债权',
        icon: UnorderedListOutlined,
        path: '/debt-management/my-debts'
      },
      {
        key: 'my-debts-intents',
        title: '投资代理',
        icon: DollarOutlined,
        path: '/debt-management/intents'
      },
      {
        key: 'debt-drafts',
        title: '债权草稿',
        icon: SaveOutlined,
        path: '/debt-management/drafts'
      },
      {
        key: 'batch-publish',
        title: '批量发布',
        icon: UploadOutlined,
        path: '/debt-management/batch-publish'
      },
      {
        key: 'my-debts-followup',
        title: '跟进日志',
        icon: UnorderedListOutlined,
        path: '/debt-management/followup'
      }
    ]
  },
  {
    key: 'debt-notice',
    title: '债权催告',
    icon: PhoneOutlined,
    path: '/debt-notice',
    children: [
      {
        key: 'debt-notice-publish',
        title: '发布催告',
        icon: PhoneOutlined,
        path: '/debt-notice/publish'
      },
      {
        key: 'debt-notice-template',
        title: '催告模板',
        icon: FileTextOutlined,
        path: '/debt-notice/template'
      },
      {
        key: 'debt-notice-history',
        title: '催告历史及重发',
        icon: UnorderedListOutlined,
        path: '/debt-notice/history'
      }
    ]
  },
  {
    key: 'profile',
    title: '认证与个人中心',
    icon: UserOutlined,
    path: '/profile',
    children: [
      {
        key: 'identity-verification',
        title: '实名认证',
        icon: SafetyOutlined,
        path: '/profile/identity-verification'
      },
      {
        key: 'account-settings',
        title: '账户设置',
        icon: SettingOutlined,
        path: '/profile/account-settings'
      },
      {
        key: 'seal-management',
        title: '印签管理',
        icon: ProfileOutlined,
        path: '/profile/seal-management'
      }
    ]
  },
  {
    key: 'membership',
    title: '会员充值',
    icon: WalletOutlined,
    path: '/membership',
    children: [
      {
        key: 'wallet',
        title: '我的钱包',
        icon: WalletOutlined,
        path: '/wallet'
      },
      {
        key: 'recharge',
        title: '会员充值',
        icon: GiftOutlined,
        path: '/recharge'
      },
      {
        key: 'consumption',
        title: '消费记录',
        icon: TransactionOutlined,
        path: '/consumption'
      }
    ]
  }
];

// 移动端底部导航配置（核心功能）
export const mobileBottomNavConfig = [
  {
    key: 'publish-debt',
    title: '发布债权',
    icon: PlusOutlined,
    path: '/debt-management/publish'
  },
  {
    key: 'debt-marketplace',
    title: '债权广场',
    icon: ShopOutlined,
    path: '/debt-marketplace/browse'
  },
  {
    key: 'my-debts',
    title: '我的债权',
    icon: UnorderedListOutlined,
    path: '/debt-management/my-debts'
  },
  {
    key: 'debt-notice',
    title: '债权催告',
    icon: PhoneOutlined,
    path: '/debt-notice/publish'
  },
  {
    key: 'wallet',
    title: '我的钱包',
    icon: WalletOutlined,
    path: '/wallet'
  }
];

// 获取扁平化的菜单项（用于路由生成）
export const getFlatMenuItems = () => {
  const flatItems = [];
  
  const flatten = (items) => {
    items.forEach(item => {
      flatItems.push(item);
      if (item.children) {
        flatten(item.children);
      }
    });
  };
  
  flatten(menuConfig);
  return flatItems;
};

// 根据路径查找菜单项
export const findMenuItemByPath = (path) => {
  const flatItems = getFlatMenuItems();
  return flatItems.find(item => item.path === path);
};

// 获取面包屑导航
export const getBreadcrumbItems = (path) => {
  const breadcrumbs = [];
  
  const findPath = (items, targetPath, parents = []) => {
    for (const item of items) {
      const currentPath = [...parents, item];
      
      if (item.path === targetPath) {
        breadcrumbs.push(...currentPath);
        return true;
      }
      
      if (item.children && findPath(item.children, targetPath, currentPath)) {
        return true;
      }
    }
    return false;
  };
  
  findPath(menuConfig, path);
  return breadcrumbs;
};
